let commons;

export const getCommonAnalytics = () => commons;

export const createCommonAnalytics = eventHandlers => {
  if (window.CommonAnalytics) {
    return (commons = new CommonAnalytics(eventHandlers));
  }
};
